import { PaginationProps } from 'antd'
import { IListReqBody } from '@types'
import { useState } from 'react'

export type UseRequestParams<T extends { model: Record<any, any> }> = {
  initParams: T
  paginationProps?: PaginationProps
}

export type UseRequestParamsReturn<T extends { model: Record<any, any> }> = {
  reqParams: IListReqBody & T
  afterPageChange: (fetchedItemsNumber: number) => void
  setParams: (params: T) => void
  pagination: PaginationProps
}

export function useRequestParams<T extends { model: Record<any, any> }>(
  props?: UseRequestParams<T>,
): UseRequestParamsReturn<T> {
  const { initParams, paginationProps = {} } = props || {}
  const { pageSize: initPageSize = 20, defaultCurrent = 0 } = paginationProps

  const [params, setParams] = useState<T>({ model: {}, ...initParams })
  const [index, setIndex] = useState(defaultCurrent)
  const [totalItems, setTotalItems] = useState(0)
  const [pageSize, setPageSize] = useState(initPageSize)

  const afterPageChange = (fetchedItemsNumber: number) => {
    // HACK: BE doesn't send total number of items. This function decides either to add one more available page or no
    const total =
      // on current page if less items than page size don't add more pages
      fetchedItemsNumber < pageSize
        ? (index + 1) * pageSize
        : // add page if different
          (index + 1) * pageSize + 1
    setTotalItems(total)
  }

  const onChange = (page: number) => {
    setIndex(page - 1)
  }

  const onParamsChange = (params: T) => {
    setTotalItems(0)
    setParams(params)
  }

  const onShowSizeChange = (size: number, next: number) => {
    setTotalItems(0)
    setPageSize(next)
  }

  return {
    setParams: onParamsChange,
    afterPageChange,
    reqParams: {
      index,
      entriesPerPage: pageSize,
      ...params,
    },
    pagination: {
      onChange,
      defaultPageSize: pageSize,
      current: index + 1,
      total: totalItems,
      pageSize,
      onShowSizeChange,
    },
  }
}
